import axios from 'axios'
import { host } from '../../helper/config'
import { FULL_LIST_ITEM_PER_PAGE, getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-carts'
const TICKET_PLUGIN_NAME = 'admin-tickets'

// GET LIST WITHDRAW
export const getListCart = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list-cart`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getCsvCart = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-csv-cart`, {
        ...query,
        page: page,
        itemPerPage: FULL_LIST_ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getCartStatistics = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-statistics`, query, {
        headers: { 'Content-Type': 'application/json', 'Authorization': token }
    })
    return response && response.status === 200 ? response.data || {} : null
}

// DELETE/CANCEL ALL TICKETS IN A CART
export const cancelCart = async (token, cartId, tickets) => {
    try {
        // Statuses 6, 7 and 8 are all cancelled ticket states.
        const cancelledStatuses = [6, 7, 8]
        const activeTickets = tickets.filter(ticket => !cancelledStatuses.includes(ticket.status))
        
        if (activeTickets.length === 0) {
            return {
                success: false,
                message: 'Không có vé nào để hủy'
            }
        }

        // Delete each ticket
        const deletePromises = activeTickets.map(ticket => 
            axios.post(`${host}/${TICKET_PLUGIN_NAME}/delete-ticket`, {
                ticketId: ticket.id
            }, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            })
        )

        const results = await Promise.all(deletePromises)
        
        // Check if all deletions were successful
        const allSuccessful = results.every(res => res.status === 200)
        
        if (allSuccessful) {
            // After successfully deleting all tickets, cancel the print queue for classic cart
            try {
                await axios.post(`${host}/admin-print-queue/cancel-classic-cart`, {
                    cartId: cartId
                }, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        'Authorization': token
                    },
                })
                console.log('Cancelled print queue for classic cart:', cartId)
            } catch (queueError) {
                console.error('Error cancelling print queue for cart:', cartId, queueError)
                // Don't fail the whole operation if print queue cleanup fails
            }
            
            return {
                success: true,
                message: `Đã hủy thành công ${activeTickets.length} vé`
            }
        } else {
            return {
                success: false,
                message: 'Có lỗi xảy ra khi hủy vé'
            }
        }
    } catch (error) {
        console.error('Error canceling cart:', error)
        return {
            success: false,
            message: 'Có lỗi xảy ra khi hủy vé'
        }
    }
}
